import { Image, StyleSheet, View } from '@react-pdf/renderer';
import React from 'react';

import commonStyles from '../../Common/commonStyles';

import Details from './Details';

const styles = StyleSheet.create({
  detailsContainer: {
    height: '25%',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    marginHorizontal: commonStyles.marginHorizontal,
    marginBottom: '4%',
  },
  image: {
    objectFit: 'contain',
    width: '50%',
    padding: '2.5% 5%',
    border: '1px solid #b8b8b8',
  },
});

function DetailsPage({ specification }) {
  const { title, code, brand, category, season, specificationTeamMembersNode, mainPhoto } =
    specification;
  return (
    <View style={styles.detailsContainer}>
      <Image style={styles.image} src={mainPhoto} />
      <Details
        admins={specificationTeamMembersNode?.adminName}
        brand={brand}
        category={category}
        code={code}
        designers={specificationTeamMembersNode?.designerName}
        patternMaker={specificationTeamMembersNode?.patternerName}
        season={season}
        specificationMemberProduction={specificationTeamMembersNode?.productionName}
        title={title}
      />
    </View>
  );
}

export default DetailsPage;
